// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "transfer-3nxqq";
var _3 = "transfer__layover-3_KQ0";
export { _1 as "__esModule", _2 as "transfer", _3 as "transfer__layover" }
export default { "__esModule": _1, "transfer": _2, "transfer__layover": _3 }
